import useCheckUpdatingFile from '@/hooks/useCheckUpdatingFile';

import Navigation from '../../_components/common/Navigation';

const PdfNavigation = () => {
  const { isDisabled, handleDisabledButtonClick } = useCheckUpdatingFile();

  const NAVIGATION_NAMES = [
    {
      name: '열람 분석',
      icon: 'ph:chart-bar',
      route: '/user/pdf/activity-analysis',
      className: 'pdf-activity-analysis',
    },
    {
      name: '고객 목록',
      icon: 'ph:users',
      route: '/user/pdf/tracking-clients',
      className: 'pdf-tracking-clients',
    },
    {
      name: '뷰어 설정',
      icon: 'ph:gear-fine',
      route: '/user/pdf/share-setting',
      className: 'pdf-share-setting',
      isDisabled,
      onClick: handleDisabledButtonClick,
    },
  ] as const;

  return <Navigation navigations={NAVIGATION_NAMES} />;
};

export default PdfNavigation;
